<template>
  <div id="legend" class="bg-white border rounded border-primary legend" :class="{'show':show()}">
    <div class="container">
      <div class="row justify-content-between">
        <div class="p-2">
          <h3>Legenda</h3>
        </div>
        <div class="p-2">
          <i class="fas fa-window-close closer" style="font-size: 2.6em" @click="hideLegend"></i>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-3" v-for="lconfig in layerconfig()" :key="lconfig.name">
          <div class="d-flex align-items-center">
            <input
              type="checkbox"
              :name="lconfig.name"
              :disabled="!lconfig.userSelectable"
              v-model="lconfig.visible"
              @change="updateLayer({name:lconfig.name,visible:lconfig.visible})"
            />
            <span class="p-2 font-weight-bold">{{lconfig.label}}</span>
          </div>
          <div v-for="soort in config()['soort' + lconfig.name]" :key="soort.id">
            <img
              :src="'/soort/'+lconfig.name.toLowerCase()+'/'+soort.id + '/icon'"
              width="20"
              height="20"
            />
            <span>{{soort.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { HIDE_LEGEND, UPDATE_VISIBILITY } from "../store/mutation-types";
import { UPDATE_LAYER_VISIBILITY } from "../store/action-types";

import {
  GET_LAYERCONFIG,
  GET_CONFIG,
  GET_LEGEND_SHOW,
} from "../store/getters-types";
export default {
  methods: {
    ...mapActions({
      updateLayer: UPDATE_LAYER_VISIBILITY,
    }),
    ...mapMutations({
      hideLegend: HIDE_LEGEND,
    }),
  },
  computed: {
    ...mapGetters({
      show: GET_LEGEND_SHOW,
      config: GET_CONFIG,
      layerconfig: GET_LAYERCONFIG,
    }),
  },
};
</script>
<style lang="scss" scoped>
.legend {
  position: absolute;
  z-index: 2000;
}
</style>